// extracted by mini-css-extract-plugin
module.exports = {"container":"AssessorAssessmentHeader_container__3ZWsK","searchbarWrapper":"AssessorAssessmentHeader_searchbarWrapper__3nqG9"};